<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: fan.wu
 * @Date: 2020-04-08
 * @LastEditors: fan.wu
 * @LastEditTime: 2020-04-08
 -->
<template>
  <div class="page-container">
    <div class="basic-info">
      <div class="basic-info-head">
        <div class="grid-content-head">
          <img src="@/systemManage/public/resource/icon/base-info.png" style="display:inline;margin-right:5px" alt="" />
          <span style="display:inline">基础信息</span>
        </div>
      </div>
      <div class="basic-info-body">
        <el-row :gutter="40">
          <el-col :span="6" class="my-el-col-head">
            <div class="head-cell-container">
              <div class="grid-content-info">
                <span class="span-head">姓名</span>
                <span class="span-body" v-if="accountInfo.name">{{
                  accountInfo.name
                }}</span>
                <a class="span-body-none" v-else>{{ '<未设置>' }}</a>
              </div>
              <div class="head-cell-img-container">
                <img src="@/systemManage/public/resource/icon/xingming.png" alt="" class="img-cell-head"
                  style="display:inline;margin-right:5px" />
              </div>
            </div>
          </el-col>
          <el-col :span="6" class="my-el-col-head">
            <div class="head-cell-container">
              <div class="grid-content-info">
                <span class="span-head">账号</span>
                <span class="span-body" v-if="accountInfo.loginName">{{
                  accountInfo.loginName
                }}</span>
                <a class="span-body-none" v-else>{{ '<未设置>' }}</a>
              </div>
              <div class="head-cell-img-container">
                <img src="@/systemManage/public/resource/icon/zhanghao.png" alt="" class="img-cell-head"
                  style="display:inline;margin-right:5px" />
              </div>
            </div>
          </el-col>
          <el-col :span="6" class="my-el-col-head">
            <div class="head-cell-container">
              <div class="grid-content-info">
                <span class="span-head">昵称</span>
                <a class="span-body-none" v-if="accountInfo.nickName"
                  @click="didTapToDoWithValue(nickNameItem)">{{ accountInfo.nickName }}</a>
                <a class="span-body-none" v-else @click="didTapToDoWithNoValue(nickNameItem)">{{ '<未设置>' }}</a>
              </div>
              <div class="head-cell-img-container">
                <img src="@/systemManage/public/resource/icon/nichen.png" alt="" class="img-cell-head"
                  style="display:inline;margin-right:5px" />
              </div>
            </div>
          </el-col>
          <el-col :span="6" class="my-el-col-head-last">
            <div class="head-cell-container">
              <div class="grid-content-info">
                <span class="span-head">有效期</span>
                <span class="span-body" v-if="
                    accountInfo.lifeTime === null || accountInfo.lifeTime === ''
                  ">永久</span>
                <span class="span-body" v-else>{{ accountInfo.lifeTime }}</span>
              </div>
              <div class="head-cell-img-container">
                <img src="@/systemManage/public/resource/icon/youxiaoqi.png" alt="" class="img-cell-head"
                  style="display:inline;margin-right:5px" />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="bottom-container">
      <el-row :gutter="20" style="width:100%;margin:0">
        <el-col :span="16" style="padding-left:0;">
          <div class="basic-info">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="登录日志查询" name="first">
                <log-check ref="logCheck" :option="option"></log-check>
              </el-tab-pane>
              <el-tab-pane label="信息修改日志" name="second">
                <log-change-check ref="logChangeCheck"></log-change-check>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
        <el-col :span="8" style="padding-right:0;">
          <div class="basic-info">
            <div class="basic-info-head">
              <div class="grid-content-head">
                <img src="@/systemManage/public/resource/icon/safe-status.png" style="display:inline;margin-right:5px"
                  alt="" />
                <span style="display:inline">账号安全状态</span>
              </div>
            </div>
            <div class="basic-info-body">
              <div class="option-container">
                <div class="option-item" v-for="item in modifyList" :key="item.attributeName">
                  <div>
                    <div class="div-cell">
                      <img class="img-head" v-if="item.name === 'email'"
                        src="@/systemManage/public/resource/icon/youxiang.png" alt="" />
                      <img class="img-head" v-if="item.name === 'wxgzptOpenId'"
                        src="@/systemManage/public/resource/icon/weiixn.png" alt="" />
                      <img class="img-head" v-if="item.name === 'userPassword'"
                        src="@/systemManage/public/resource/icon/mima.png" alt="" />
                    </div>

                    <div class="div-center">
                      <span class="span-modify-head">{{
                        item.attributeName
                      }}</span>
                      <span class="span-modify-body-g" v-if="
                          item.name === 'userPassword' &&
                            item.isRequiredStrength
                        ">密码强度符合要求，当前强度：{{ item.strength }}</span>
                      <span class="span-modify-body-r" v-else-if="
                          item.name === 'userPassword' &&
                            !item.isRequiredStrength
                        ">密码强度不符合要求，当前强度：{{ item.strength }}</span>
                      <span class="span-modify-body" v-else-if="item.value !== ''">{{ item.haveValueTips }}</span>
                      <span class="span-modify-body-no-value" v-else>{{
                        item.noValueTips
                      }}</span>
                    </div>

                    <div v-if="item.name === 'wxgzptOpenId'"></div>
                    <div class="div-right" v-else>
                      <a class="span-body-option" @click="didTapToDoWithValue(item)"
                        v-if="item.value !== ''">{{ item.haveValueActionName }}</a>
                      <a class="span-body-option" @click="didTapToDoWithNoValue(item)"
                        v-else>{{ item.noValueActionName }}</a>
                    </div>
                  </div>
                </div>

                <!-- 插槽，扩展设置功能-->
                <slot name="settingSlot"></slot>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 弹窗 -->
    <div v-if="showWindow" class="div-el-dialog" @click.stop="didTapClose"></div>
    <div v-if="showWindow" class="div-el-dialog-wrapper">
      <option-window @hideWindow="didTapClose" :editItem="editItem"></option-window>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/framework/util/auth'
import { getStrenth } from '@/systemManage/framework/utils/tools'
import optionWindow from '@/systemManage/framework/components/optionWindow'
import logCheck from '@/systemManage/framework/components/logCheck'
import logChangeCheck from '@/systemManage/framework/components/logChangeCheck'
export default {
  name: 'AccountCenter',
  props: ['option'],
  components: {
    optionWindow,
    logCheck,
    logChangeCheck
  },
  data() {
    return {
      userInfo: {},
      accountInfo: {},
      modifyList: [],
      showWindow: false,
      editItem: {},
      activeName: 'first',
      nickNameItem: {} // 昵称特殊处理
    }
  },
  created: function () {
    this.userInfo = getUserInfo()
    this.funcGetAccountInfo()
  },
  mounted: function () { },
  methods: {
    // 获取用户信息
    funcGetAccountInfo: function (account) {
      this.$http
        .post('/self/retrieve-password/account-info', {
          loginName: this.userInfo.subject.loginName
        })
        .then(response => {
          this.accountInfo = response.data
          this.compType = 'account'
          this.getModifyField()
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
    },

    // 获取可编辑的用户信息
    getModifyField() {
      this.$http
        .get('/self/account/modify-field', { params: {} })
        .then(response => {
          var modifyList = []
          var modifyFieldInfo = response.data
          for (var key in modifyFieldInfo) {
            modifyFieldInfo[key].headImg = key
            modifyFieldInfo[key].name = key
            modifyFieldInfo[key].strength = ''
            if (modifyFieldInfo[key].name === 'userPassword') {
              modifyFieldInfo[key].value = this.accountInfo[key]
                ? this.accountInfo[key]
                : '000000' // 密码默认有
              modifyFieldInfo[key].strength = getStrenth(
                this.accountInfo['currentPasswordStrength']
              )
              modifyFieldInfo[key].needStrength = getStrenth(
                this.accountInfo['passwordStrength']
              )
              modifyFieldInfo[key].currentPasswordStrength = this.accountInfo[
                'currentPasswordStrength'
              ]
              modifyFieldInfo[key].passwordStrength = this.accountInfo[
                'passwordStrength'
              ]
              modifyFieldInfo[key].isRequiredStrength =
                parseInt(this.accountInfo['currentPasswordStrength']) >=
                parseInt(this.accountInfo['passwordStrength'])
            } else {
              modifyFieldInfo[key].value = this.accountInfo[key]
                ? this.accountInfo[key]
                : ''
            }

            if (key === 'nickName') {
              this.nickNameItem = modifyFieldInfo[key]
              continue
            } else {
              modifyList.push(modifyFieldInfo[key])
            }
          }
          this.modifyList = modifyList
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
    },

    // 隐藏弹窗
    didTapClose() {
      this.showWindow = false
      this.funcGetAccountInfo()
      this.getModifyField()
    },

    // 操作用户信息（有值）
    didTapToDoWithValue(item) {
      this.showWindow = true
      this.editItem = item
    },

    // 操作用户信息（无值）
    didTapToDoWithNoValue(item) {
      this.showWindow = true
      this.editItem = item
    },

    // 切换Tab
    handleClick(tab, event) {
      if (tab.name === 'first') {
        this.$refs.logCheck.onLoad()
      } else {
        this.$refs.logChangeCheck.onLoad()
      }
    },

    didTapToSecondAuth() {
      this.router.push({ path: '' })
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  cursor: pointer;
}
.page-container {
  padding: 3.125rem 6.25rem;
  padding-top: 0;
}

.basic-info {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 1.25rem 1.875rem;
  margin-top: 1.25rem;
}
.basic-info-head {
  width: 100%;
  // height: 0.25rem;
  vertical-align: middle;
  padding-bottom: 0.625rem;
  border-bottom: 1px solid #ebeef5;
}

.basic-info-body {
  margin-top: 1.875rem;
}
.my-el-col-head {
  padding-right: 2.5rem !important;
  border-right: 1px solid #ebeef5;
}
.my-el-col-head-last {
  padding-right: 2.5rem !important;
}
.head-cell-container {
  width: 100%;
  height: 5rem;
}
.head-cell-img-container {
  float: right;
}
.img-cell-head {
  height: 5rem;
  width: 5rem;
}
.grid-content-info {
  //margin-left: 1.25rem;
  min-height: 2.25rem;
  float: left;
  display: flex;
  flex-direction: column;
}
.grid-content-head {
  display: flex;
  width: 12.5rem;
}
.span-head {
  color: #808080;
  font-size: 0.875rem;
  margin-top: 0.625rem;
}
.span-body {
  color: #434343;
  font-size: 1.125rem;
  margin-top: 0.625rem;
}
.span-body-none {
  color: #4da2ff;
  font-size: 1.125rem;
  margin-top: 0.625rem;
}

.option-container {
  display: flex;
  flex-direction: column;
}
.option-item {
  margin-bottom: 2.5rem;
  padding: 1.25rem;
  border: 1px solid #dcdcdc;
}
.bottom-container {
  display: flex;
  flex-direction: row;
}
.grid-content-info-cell {
  margin-bottom: 1.25rem;
}
.div-center {
  float: left;
  display: flex;
  flex-direction: column;
  margin-right: 1.25rem;
}
.span-modify-head {
  color: #000000;
  font-size: 1rem;
}
.span-modify-body {
  color: #7d7d7d;
  font-size: 0.75rem;
  margin-top: 0.625rem;
}
.span-modify-body-g {
  color: #6dc732;
  font-size: 0.75rem;
  margin-top: 0.625rem;
}
.span-modify-body-r {
  color: #ff0000;
  font-size: 0.75rem;
  margin-top: 0.625rem;
}
.span-modify-body-no-value {
  color: #ff7030;
  font-size: 0.75rem;
  margin-top: 0.625rem;
}
.div-cell {
  margin-right: 0.625rem;
  float: left;
}
.img-head {
  height: 2.5rem;
  width: 2.5rem;
  line-height: 3.125rem;
  margin-top: 0.3125rem;
}
.div-right {
  float: right;
  text-align: center;
  height: 1.875rem;
  width: 4.375rem;
  background-color: #2a90fe;
  border-radius: 15px;
}
.span-body-option {
  color: #fefefe;
  font-size: 0.75rem;
  margin-top: 0.625rem;
  line-height: 1.875rem;
}

// 弹窗
.div-el-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2001;
}
.div-el-dialog-wrapper {
  background-color: rgba($color: #000000, $alpha: 0.3);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2001;
}
</style>
